import React from 'react'
import {useSelector} from 'react-redux'
import {OfferPrice} from 'components/Offer/Shared/OfferPrice'
import {GHAPreferredRateTotalPrice} from 'components/Offer/Shared/OfferPrice/GHAPreferredRateTotalPrice'
import {getCurrencyCode} from 'modules/meta/selectors'
import {
  getOfferAccessFlowSettings,
  getShowTotalPriceToggle
} from 'modules/sapiSearch/selectors'
import {getHotelIdFromAccommodationPage} from 'utils/getHotelIdFromAccommodationPage'

import {OfferSecondaryLayoutVariant} from '@vio/core/src/offer/types/OfferLayout'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

interface MainProps {
  hotelId: string
  anchorPriceTotal: number
  anchorPrice: number
  offer: SearchOffer
  variant: OfferSecondaryLayoutVariant
  isSplitBooking?: false
  showGHAPreferredRateTotalPrice?: boolean
  showPriceIndication?: boolean
}

interface SplitBookingProps {
  isSplitBooking: true
  hotelId: string
  anchorPriceTotal?: never
  anchorPrice?: never
  offer?: never
  variant?: never
  showGHAPreferredRateTotalPrice?: never
  showPriceIndication?: never
}

export const PriceComponent: React.FC<MainProps | SplitBookingProps> = ({
  hotelId,
  anchorPriceTotal,
  anchorPrice,
  offer,
  variant,
  isSplitBooking,
  showGHAPreferredRateTotalPrice = false,
  showPriceIndication = false
}) => {
  const showTotalPriceToggle = useSelector(getShowTotalPriceToggle)
  const currencyCode = useSelector(getCurrencyCode)
  const isAccommodationPage = Boolean(getHotelIdFromAccommodationPage())

  const {isSpecial, isAppLocked} = useSelector(state =>
    getOfferAccessFlowSettings(state, hotelId, offer?.id)
  )

  if (isSplitBooking) {
    return (
      <div data-id="Price">
        <OfferPrice isSplitBooking size="sm" hotelId={hotelId} />
      </div>
    )
  }

  if (!showTotalPriceToggle) {
    return (
      <div data-id="Price">
        <OfferPrice
          showAnchorPrice={false}
          offer={offer}
          anchorPrice={anchorPrice}
          hotelId={hotelId}
          size="sm"
          showAppIcon={variant === 'SecondaryDefault' && isAppLocked}
          showPriceIndication={isAccommodationPage}
          isPrivateDeal={isSpecial}
          isAppLockedDeal={isAppLocked}
        />
      </div>
    )
  }

  return (
    <div data-id="Price">
      <OfferPrice
        showAnchorPrice={false}
        anchorPriceTotal={anchorPriceTotal}
        anchorPrice={anchorPrice}
        offer={offer}
        hotelId={hotelId}
        size="sm"
        showAppIcon={variant === 'SecondaryDefault' && isAppLocked}
        showPriceIndication={showPriceIndication}
        isPrivateDeal={isSpecial}
        isAppLockedDeal={isAppLocked}
      />
      {showGHAPreferredRateTotalPrice && (
        <GHAPreferredRateTotalPrice
          value={offer.totalRate}
          currency={currencyCode as string}
        />
      )}
    </div>
  )
}
